import React from 'react';


class KakiKaki extends React.Component{
    render(){
        return(
            <div>
                <footer style={{textAlign:"center"}}> Made under pressure by Dex</footer>
            </div>
        )
    }

}

export default KakiKaki;